import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="registration" className="contact">
      <div className="container">
        <div className="registration-simple">
          <h2>Join the Builder's Evolution</h2>
          <p className="registration-subtitle">
            Ready to be part of the movement that's shaping the future of African innovation? 
            Register now for this free event and connect with fellow founders, builders, and investors.
          </p>
          <a 
            href="https://luma.com/btcyyph6" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary btn-large"
          >
            🎟️ Register on Luma →
          </a>
          <div className="registration-note">
            <small>
              <strong>Free Event</strong> • Registration handled through Luma • Wallet verification required
            </small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
